/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sorter_Body2Inputs */

const en_sorter_body2 = /** @type {(inputs: Sorter_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sorting descends through objects and through the objects inside arrays, but never reorders array elements themselves. Array position usually carries meaning, so shuffling it would change the data rather than normalize it. The output is re-emitted with two space indentation, which also makes this a convenient way to normalize formatting and key order in one pass.`)
};

const ko_sorter_body2 = /** @type {(inputs: Sorter_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`정렬은 객체와 배열 안의 객체를 따라 내려가지만, 배열 요소 자체의 순서는 바꾸지 않습니다. 배열의 위치는 보통 의미를 담고 있어서 섞으면 정규화가 아니라 데이터 변경이 됩니다. 출력은 2칸 들여쓰기로 다시 작성되므로, 서식과 키 순서를 한 번에 정규화하는 편리한 방법이기도 합니다.`)
};

const ja_sorter_body2 = /** @type {(inputs: Sorter_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`並べ替えはオブジェクトと配列内のオブジェクトをたどって降りますが、配列要素そのものの順序は変えません。配列の位置は通常意味を持つため、混ぜると正規化ではなくデータの変更になります。出力は 2 スペースインデントで書き直されるので、書式とキー順序を一度に正規化する便利な方法にもなります。`)
};

/**
* | output |
* | --- |
* | "Sorting descends through objects and through the objects inside arrays, but never reorders array elements themselves. Array position usually carries meaning,..." |
*
* @param {Sorter_Body2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const sorter_body2 = /** @type {((inputs?: Sorter_Body2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sorter_Body2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sorter_body2(inputs)
	if (locale === "ko") return ko_sorter_body2(inputs)
	return ja_sorter_body2(inputs)
});